<template>
  <div class="text-center">
    <p class="mb-4">
      Usa tu cuenta de ahorros o corriente, recuerda que debes tener activo el
      servicio de clave dinámica de la App Bancolombia. Asegúrate de tener
      <b>
        ${{ new Intl.NumberFormat('de-DE').format(dataCart?.carrito_total) }}
      </b>
      para finalizar tu compra.
    </p>
    <button
      class="bnt-primary col-12 col-lg-10 col-xl-5 mx-auto"
      @click="payBancolombia()"
    >
      Pagar con Bancolombia
    </button>
    <div v-if="errorPaymentBancolombia" class="text-center my-3">
      <span class="text-error">{{ errorPaymentBancolombia }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { GA4AddPaymentAnonymous, GA4PurchaseAnonymous } from '@/GA4/events'
import { sendFBQEvent } from '@/fbq'
export default {
  data() {
    return {
      errorPaymentBancolombia: '',
    }
  },
  computed: {
    ...mapState('cart', ['dataCart']),
  },
  methods: {
    async payBancolombia() {
      this.$store.state.loaderClover = true
      const event_id_fb = 'initiate_checkout-' + crypto.randomUUID()
      sendFBQEvent(this, 'InitiateCheckout', { event_id: event_id_fb })
      data.append('event_id_fb', event_id_fb)
      this.errorPaymentBancolombia = ''
      let data = new FormData()
      data.append('token', this.$route.params.tokenCart)
      await this.axios({
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/payment/bancolombia/compra',
        data: data,
      })
        .then(response => {
          GA4AddPaymentAnonymous('Bancolombia')
          GA4PurchaseAnonymous()
          location.href = response.data
        })
        .catch(err => {
          this.$store.state.loaderClover = false
          if (err.response.status == 423) {
            this.$bvModal.show('modal-products-sold-out')
          } else if (err.response.status == 406) {
            this.$bvModal.show('modal-error-406')
            this.msgModalExcepcion406 = err.response.data.errors.bono_regalo[0]
            this.btnModalExcepcion406 = 'pse'
          } else {
            this.errorPaymentBancolombia = err.response.data.response.msg
          }
        })
    },
  },
}
</script>
